import { ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from '../../components';
import { ResetPasswordComponent } from '../../components/reset-password/reset-password.component';
import { LoginModule } from '../modules';

const loginRoutes = [
  {
    path: '',
    component: LoginComponent
  }
];

export const LoginRouting: ModuleWithProviders<LoginModule> = RouterModule.forChild(loginRoutes);
